<div
  id="mol-button-link"
  [ngClass]="{ disable: disable, medium: size === eButtonSizes.m, active: select, small: size === eButtonSizes.s }"
  (click)="handleSubmit()"
  (mouseenter)="isHover = true"
  (mouseleave)="isHover = false">
  <div *ngIf="firstIcon" class="iconContainer">
    <atm-icon
      [cursorType]="disable ? eCursorType.notAllowed : eCursorType.pointer"
      [enableForceHover]="true"
      [iconKey]="firstIcon"
      [isDisabled]="disable"
      [isHover]="select ? true : isHover"
      [size]="size === eButtonSizes.s ? iconSizes.Size20 : iconSizes.Size24"
      [statusIcon]="disable ? eStatusIcon.disable : eStatusIcon.default">
    </atm-icon>
  </div>
  <div class="textContainer">
    <atm-text-ui
      [cursorType]="disable ? eCursorType.notAllowed : eCursorType.pointer"
      [fontColor]="handleFontColor()"
      [fontWeight]="eFontWeight.medium"
      [textDecoration]="eTextDecoration.underline">
      <ng-content></ng-content>
    </atm-text-ui>
  </div>
  <div *ngIf="secondIcon" class="iconContainer">
    <atm-icon
      [cursorType]="disable ? eCursorType.notAllowed : eCursorType.pointer"
      [enableForceHover]="true"
      [iconKey]="firstIcon"
      [isDisabled]="disable"
      [isHover]="select ? true : isHover"
      [size]="size === eButtonSizes.s ? iconSizes.Size20 : iconSizes.Size24"
      [statusIcon]="disable ? eStatusIcon.disable : eStatusIcon.default">
    </atm-icon>
  </div>
</div>
